import { Annotation } from '@rossum/api-client/annotations';
import { AnnotationStatus } from '@rossum/api-client/shared';
import { GridFilterItem } from '@rossum/ui/x-data-grid-pro';
import { camelToSnake } from '../../../lib/keyConvertor';
import type { Prettify } from '../../../lib/typeUtils';
import { snakeCaseStatuses } from '../../../types/annotationStatus';
import { AttachmentStatus } from '../../../types/attachmentStatus';

export type NormalizedAnnotations = Array<
  Prettify<
    Pick<Annotation, 'id' | 'url' | 'status' | 'document' | 'queue'> & {
      attachmentStatus: AttachmentStatus;
    }
  >
>;

export const normalizeAnnotations = (annotations: NormalizedAnnotations) =>
  annotations.reduce<{
    ids: number[];
    statuses: AnnotationStatus[];
  }>(
    (acc, { id, status }) => ({
      ids: [...acc.ids, id],
      statuses: [...acc.statuses, camelToSnake(status)],
    }),
    { ids: [], statuses: [] }
  );

export const getExistingStatusFilter = (
  existingFilterItems: GridFilterItem[]
) => {
  const existingValue = existingFilterItems.filter(
    item => item.field === 'status' && item.operator === 'isAnyOf'
  )[0]?.value;

  if (!Array.isArray(existingValue)) return undefined;

  return existingValue.filter((status): status is AnnotationStatus =>
    snakeCaseStatuses.includes(status)
  );
};

export const reviewableStatuses = [
  'to_review',
  'reviewing',
  'postponed',
  'confirmed',
] as const satisfies Array<AnnotationStatus>;
